module.exports = __webpack_public_path__ + "img/superhero.4aec15cd.svg";